// removed by extract-text-webpack-plugin
module.exports = {"field-item-wrapper":"field-item-wrapper","field-item":"field-item","isSortable":"isSortable","dragHandle":"dragHandle","required":"required","icon-cancel":"icon-cancel","icon-cog":"icon-cog"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/CustomField/FieldItem.scss
// module id = Ci3R
// module chunks = 0